import '@custom/ui/styles.css';

import { GatsbyBrowser } from 'gatsby';

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = (
  args,
) => {
  // Tell Gatsby to only update scroll position if the pathname or hash has changed.
  // If only the search has changed (e.g. when a search form is submitted),
  // the scroll position should remain the same.
  const current = args.routerProps.location;
  const previous = args.prevRouterProps?.location;
  return (
    current.pathname !== previous?.pathname || current.hash !== previous?.hash
  );
};

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackEvent(name: string) {
  if (window.gtag) {
    window.gtag('event', name);
  }
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  const iframe = document.querySelector<HTMLIFrameElement>(
    'iframe[src*="guyharveyfoundation.org"]',
  );
  if (!iframe) return;

  let visibilityFired = false;
  let clickFired = false;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (visibilityFired) {
        observer.disconnect();
        return;
      }
      if (entry.isIntersecting) {
        timer = setTimeout(() => {
          visibilityFired = true;
          trackEvent('iframe_visible');
          observer.disconnect();
        }, 5000);
      } else if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    },
    { threshold: 0.5 },
  );
  observer.observe(iframe);

  const onBlur = () => {
    if (clickFired) return;
    if (document.activeElement === iframe) {
      clickFired = true;
      trackEvent('iframe_click');
      window.removeEventListener('blur', onBlur);
    }
  };
  window.addEventListener('blur', onBlur);
};
